import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PasswordValidator {
   static readonly MatchPassword = (controlName: string, matchingControlName: string): ValidatorFn => {
      return (formGroup: AbstractControl): ValidationErrors | null => {
         /* Check if the room name already exists */
         const control: string = formGroup.get(controlName)?.value;
         const matchingControl: string = formGroup.get(matchingControlName)?.value;

         // use data param
         if (control !== matchingControl) {
            formGroup.get(matchingControlName)?.setErrors({ ConfirmPassword: true });
            return { ConfirmPassword: true };
         }

         return null;
      }
   }
}
